(() => {
  'use strict';

  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-slide]')];
    const dots = [...slider.querySelectorAll('[data-slide-dot]')];
    if (!slides.length) return;

    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer;
    let startX = 0;
    let startY = 0;
    let pointerId = null;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-selected', String(dotIndex === index)));
    };

    const restart = () => {
      window.clearInterval(timer);
      if (slider.dataset.autoplay === 'true' && slides.length > 1) {
        timer = window.setInterval(() => show(index + 1), Number(slider.dataset.speed) || 6000);
      }
    };

    const previous = () => { show(index - 1); restart(); };
    const next = () => { show(index + 1); restart(); };

    // Prevent the browser's native image drag from swallowing the swipe.
    slider.querySelectorAll('img').forEach((image) => {
      image.draggable = false;
      image.addEventListener('dragstart', (event) => event.preventDefault());
    });
    slider.addEventListener('dragstart', (event) => event.preventDefault());

    slider.querySelector('[data-slide-prev]')?.addEventListener('click', previous);
    slider.querySelector('[data-slide-next]')?.addEventListener('click', next);
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.slideDot) || 0); restart(); }));

    slider.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); previous(); }
      if (event.key === 'ArrowRight') { event.preventDefault(); next(); }
    });

    slider.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || event.target.closest('button, a, input, textarea, select')) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      try { slider.setPointerCapture?.(pointerId); } catch (_) { /* pointer already released */ }
    });

    slider.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const horizontal = Math.abs(event.clientX - startX);
      const vertical = Math.abs(event.clientY - startY);
      if (horizontal > 8 && horizontal > vertical) {
        event.preventDefault();
      }
    }, { passive: false });

    slider.addEventListener('pointerup', (event) => {
      if (event.pointerId !== pointerId) return;
      const distance = event.clientX - startX;
      const vertical = Math.abs(event.clientY - startY);
      pointerId = null;
      if (Math.abs(distance) >= 45 && Math.abs(distance) > vertical) distance < 0 ? next() : previous();
    });

    window.addEventListener('pointerup', (event) => {
      if (event.pointerId !== pointerId) return;
      const distance = event.clientX - startX;
      const vertical = Math.abs(event.clientY - startY);
      pointerId = null;
      if (Math.abs(distance) >= 45 && Math.abs(distance) > vertical) distance < 0 ? next() : previous();
    });
    window.addEventListener('pointercancel', (event) => {
      if (event.pointerId === pointerId) pointerId = null;
    });
    slider.addEventListener('mouseenter', () => window.clearInterval(timer));
    slider.addEventListener('mouseleave', restart);

    document.addEventListener('shopify:block:select', (event) => {
      const selected = event.target.closest?.('[data-slide]');
      const selectedIndex = selected ? slides.indexOf(selected) : -1;
      if (selectedIndex >= 0) { show(selectedIndex); window.clearInterval(timer); }
    });

    show(index);
    restart();
  });
})();
